// Danske tekster til push-beskeder under Mig.
const pushTexts = {
  title: 'Beskeder',
  installHint: 'Installér appen på hjemmeskærmen for at få beskeder',
  device: 'Beskeder på denne enhed',
  deviceHint: 'Slå til for at få besked på telefonen, når der sker noget i din klub.',
  blocked: 'Beskeder er blokeret i browseren. Slå dem til i browserens indstillinger for siden.',
  gameStarted: 'Spil startet i min klub',
  gameCompleted: 'Spil afsluttet',
  gameCompletedHint: 'Med dit resultat fra aftenen',
  invited: 'Invitationer',
  sendTest: 'Send testbesked',
  testSent: 'Testbesked sendt',
  testNone: 'Ingen enheder fik beskeden',
  couldNotSubscribe: 'Kunne ikke slå beskeder til',
  couldNotUnsubscribe: 'Kunne ikke slå beskeder fra',
  couldNotSavePrefs: 'Kunne ikke gemme indstillingen',
  couldNotSendTest: 'Kunne ikke sende testbesked'
}

export default pushTexts
